export const RISK_SCORE_SETUP_COPY = {
  pageTitle: "Score pull request risk",
  title: "How does SuperPlane score risk?",
  helper: "When a pull request opens or updates, an agent reviews the diff and adds a risk score to the task.",
  scaleHeading: "Risk scale",
  scaleHelper: "A higher score means more risk.",
  categoriesTitle: "Which changes are high risk?",
  categoriesHelper: "Set the lowest score for each kind of change. The pull request score is the highest match.",
  addMore: "Add more",
  addTitle: "Add a category",
  addNameLabel: "Category name",
  addScoreLabel: "Risk",
  addButton: "Add",
  addDuplicate: "This category already exists.",
  addInvalid: "Do not use an equals sign in the name.",
  cancel: "Cancel",
  remove: "Remove",
  save: "Save categories",
  saving: "Saving...",
  scale: [
    { score: 1, label: "Very low", status: "Minimal Risk", tone: "low" },
    { score: 2, label: "Low", status: "Low Risk", tone: "low" },
    { score: 3, label: "Medium", status: "Moderate Risk", tone: "caution" },
    { score: 4, label: "High", status: "High Risk", tone: "critical" },
    { score: 5, label: "Critical", status: "Severe Risk", tone: "critical" },
  ],
  back: "Back to board",
  finish: "Add risk score",
  finishing: "Adding...",
  created: "Risk score added.",
  missingGitHub: "Connect GitHub in workspace setup before you add the risk score.",
  previewLabel: "Example task check",
  previewTaskLabel: "Task",
  previewTaskKey: "SP-184",
  previewCheckName: "Risk score",
  previewSummary: "Adds a retry to the payment webhook. The change is small and has tests.",
  previewCaption: "The score appears on the task.",
} as const;
